import React, { Fragment } from 'react';
import Breadcrumb from '../../../layout/breadcrumb';
import { Card, CardBody, Container, Row, Col, Button } from 'reactstrap';
import { usePrinterPoints } from '../../../hooks/printerPoints/usePrinterPoints';
import { PrinterPointList } from '../../../constant';
import { TableStriped } from '../../../components/tables/TableStriped';
import { ModalPrinterPoint } from '../../../components/printerPoints/ModalPrinterPoint';
import { ListPrinter } from './ListPrinter';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexPrinterPoints = () => {

    const {
        printerPoints, method,
        name, username, password, password_confirmation, handleInputChange, validaciones,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        mSelectBranch, branches, handleSelectValues,
        modalAlert, closeDeleteAlert, showDeleteAlert,
        handleExcelPrintPoint, loadingExcel,
        searchPrintPoint,
        handleClearPrintPoint, handleSearchPrintPoint
    } = usePrinterPoints();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_printer_point)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_printer_point)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    // let filter = ["namePrinter"];

    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Row>
                    <Col md="12">
                        {/* <Card> */}
                        <CardBody className="p-1 mt-2">
                            <TitleDataTable
                                titleTable="Puntos de impresión"
                                buttonActions={handleExcelPrintPoint}
                                titleButton="Puntos de impresión"
                                isDisbled={loadingExcel}
                                loadingIsDisabled={loadingExcel}
                                titleCreate="Crear punto de impresión"
                                buttonActionsCreate={handleCreate}
                                actionInput={handleSearchPrintPoint}
                                valueFilter={searchPrintPoint}
                                filterLocalStorage={true}
                                cleanFilterLocalStorage={handleClearPrintPoint}
                            />

                            <div className="table-responsive">
                                <DataTable
                                    value={printerPoints}
                                    paginator
                                    rows={15}
                                    responsiveLayout="scroll"
                                    rowsPerPageOptions={[15, 50, 100]}
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    emptyMessage={
                                        <div className="text-center">
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                style={{ width: "32%" }}
                                                alt="Sin resultados"
                                            />
                                            <br />
                                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                No se encontraron resultados.
                                            </p>
                                        </div>
                                    }
                                >

                                    <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                    <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                                    <Column field="username" header="Usuario" headerStyle={headerStyle} style={cellStyle} />
                                    <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                </DataTable>
                            </div>
                        </CardBody>
                        {/* </Card> */}
                    </Col>
                </Row>
            </div>
            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar punto de impresión"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el punto de impresión?"
                    alert1={true}
                    titleAlert1={name}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                    maskClassName="custom-total-mask"
                    newDesingDialog={true}
                    iconNewDialog="fa fa-trash-o f-20"
                    headerColor="#8b0000"
                    newDesingDialogDelete={true}
                    closable={false}
                />

            )}

            <ModalPrinterPoint
                {
                ...{
                    modal, modalTitle, closeDialog, method, loading,
                    name, username, password, password_confirmation, handleInputChange, validaciones,
                    saveCreate, saveUpdate, saveDelete, mSelectBranch, branches, handleSelectValues
                }
                }
            />
        </Fragment>
    )
}
